import { type ClassValue } from "clsx";
import { clsxMerge } from "shared/lib/helpers";

export function cn(...inputs: ClassValue[]) {
  return clsxMerge(inputs);
}
